export const erDataVersion = '1.50.0';

export const itemSkillGroupIds = [6001000, 6001010, 6002000, 6002010, 6005000, 6006000, 6007000, 6007010, 6008000, 6012000, 6013000, 6014000, 6015000, 6016000, 6017000, 6017010, 6018000, 6019000, 6020000, 6021000, 6021010, 6500000, 6501000, 6502000, 6503000, 6504000, 6505000, 6506000, 6507000, 6508000, 6509000, 6510000, 6511000, 6512000, 6513000, 6514000, 6514100] as const;

export const characterNames: Record<number, string> = {
  0: 'Random',
  1: 'Jackie',
  2: 'Aya',
  3: 'Fiora',
  4: 'Magnus',
  5: 'Zahir',
  6: 'Nadine',
  7: 'Hyunwoo',
  8: 'Hart',
  9: 'Isol',
  10: 'LiDailin',
  11: 'Yuki',
  12: 'Hyejin',
  13: 'Xiukai',
  14: 'Chiara',
  15: 'Sissela',
  16: 'Silvia',
  17: 'Adriana',
  18: 'Shoichi',
  19: 'Emma',
  20: 'Lenox',
  21: 'Rozzi',
  22: 'Luke',
  23: 'Cathy',
  24: 'Adela',
  25: 'Bernice',
  26: 'Barbara',
  27: 'Alex',
  28: 'Sua',
  29: 'Leon',
  30: 'Eleven',
  31: 'Rio',
  32: 'William',
  33: 'Nicky',
  34: 'Nathapon',
  35: 'Jan',
  36: 'Eva',
  37: 'Daniel',
  38: 'Jenny',
  39: 'Camilo',
  40: 'Chloe',
  41: 'Johann',
  42: 'Bianca',
  43: 'Celine',
  44: 'Echion',
  45: 'Mai',
  46: 'Aiden',
  47: 'Laura',
  48: 'Tia',
  49: 'Felix',
  50: 'Elena',
  51: 'Priya',
  52: 'Adina',
  53: 'Markus',
  54: 'Karla',
  55: 'Estelle',
  56: 'Piolo',
  57: 'Martina',
  58: 'Haze',
  59: 'Isaac',
  60: 'Tazia',
  61: 'Irem',
  62: 'Theodore',
  63: 'LyAnh',
  64: 'Vanya',
  65: 'Debi&Marlene',
  66: 'Arda',
  67: 'Abigail',
  68: 'Alonso',
  69: 'Leni',
  70: 'Tsubame',
  71: 'Kenneth',
  72: 'Katja',
  73: 'Charlotte',
  74: 'Darko',
  75: 'Lenore',
  76: 'Garnet',
  77: 'YuMin',
  78: 'Hisui',
  79: 'Justyna',
  80: 'Istvan',
  81: 'Niah',
  82: 'Dr.Nadja',
};
